/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Identifier_Columns_InvalidInputs */

const en_ledger_error_identifier_columns_invalid = /** @type {(inputs: Ledger_Error_Identifier_Columns_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The account identifier columns are invalid`)
};

const nl_ledger_error_identifier_columns_invalid = /** @type {(inputs: Ledger_Error_Identifier_Columns_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De identificatiekolommen zijn ongeldig`)
};

/**
* | output |
* | --- |
* | "The account identifier columns are invalid" |
*
* @param {Ledger_Error_Identifier_Columns_InvalidInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_identifier_columns_invalid = /** @type {((inputs?: Ledger_Error_Identifier_Columns_InvalidInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Identifier_Columns_InvalidInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_identifier_columns_invalid(inputs)
	return en_ledger_error_identifier_columns_invalid(inputs)
});